import React from "react";
import PropTypes from "prop-types";
import CustomModal from "components/Modal";
import Button from "components/Button";
import "./index.scss";

const WarningModal = ({ isOpen, onClose, fetchCatalog, unselectAllFields }) => {
  const handleOnClose = () => {
    onClose();
  };

  const continueFetchCatalog = () => {
    fetchCatalog();
  };

  const unselectAll = () => {
    unselectAllFields();
  };

  return (
    <CustomModal
      isOpen={isOpen}
      size="medium"
      onClose={handleOnClose}
      onRequestClose={handleOnClose}
      blurred
    >
      <div className="learn-more" data-testid="learn-more-modal-content">
        <h3 className="title">Too many field selected</h3>
        <div className="paragraph">
          We detected that you selected too many field at once, such number of
          selected fields may result to a slower response time.
        </div>
        <div>
          <Button
            type="outlined"
            color="white"
            id="proceed-button"
            label="Okay, let me proceed"
            block
            onClick={continueFetchCatalog}
          />
          <Button
            type="ghost"
            color="white"
            id="unselect-button"
            label="Unselect all fields"
            block
            onClick={unselectAll}
          />
        </div>
      </div>
    </CustomModal>
  );
};

WarningModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  fetchCatalog: PropTypes.func.isRequired,
  unselectAllFields: PropTypes.func.isRequired,
};

export default WarningModal;
